<template>
  <div class="ninePage">
    <div class="logo">
      <img :src="baseUrl + 'img/dhShare/dhLogo.png'" />
    </div>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";

export default {
  name: "ninePage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      nineTitShow: false,
      pageEightAction: false,
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.typePage = this.landscapeType;
    //   this.initPage();
    // });
  },
  methods: {},
  watch: {
    landscapeType: function (newVal) {
      this.typeType = newVal;
    },
  },
};
</script>
<style lang="less">
.ninePage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/ninePage.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  .logo {
    position: absolute;
    top: 50%;
    right: 30px;
    margin-top: -30px;
    width: 60px;
    height: 43px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg); /* IE 9 */
    -moz-transform: rotate(90deg); /* Firefox */
    -webkit-transform: rotate(90deg); /* Safari and Chrome */
    img {
      max-width: 100%;
    }
  }
}
</style>